// extracted by mini-css-extract-plugin
module.exports = {"sticky":"style_sticky__xbdXu","closebtn":"style_closebtn__VJjx7"};